import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SustainabilityHero from './components/SustainabilityHero';
import CommitmentSection from './components/CommitmentSection';
import ImpactMetrics from './components/ImpactMetrics';
import SustainabilityCTA from './components/SustainabilityCTA';

export default function SustainabilityPage() {
  return (
    <>
      <Navbar />
      <main>
        <SustainabilityHero />
        <CommitmentSection />
        <ImpactMetrics />
        <SustainabilityCTA />
      </main>
      <Footer />
    </>
  );
}